/* SJB Kleur-Galerie (07.09.2026)
   Dawn gleicht beim Variantenwechsel nur den Großbild-Slider mit dem neu gerenderten Abschnitt ab.
   Dieses Skript zieht Thumbnail-Leiste (Reihenfolge + .sjb-hide), Slider-Pfeile und Bildzähler nach. */
(function () {
  if (window.__sjbGalleryKleur) return;
  window.__sjbGalleryKleur = true;

  function sync(data) {
    if (!data || !data.html) return;
    document.querySelectorAll('product-info').forEach(function (pi) {
      var sid = pi.dataset.originalSection || pi.dataset.section;
      if (sid !== data.sectionId) return;
      var gallery = pi.querySelector('media-gallery');
      if (!gallery) return;

      var thumbs = gallery.querySelector('[id^="Slider-Thumbnails"]');
      var newThumbs = data.html.querySelector('[id^="Slider-Thumbnails"]');
      if (thumbs && !newThumbs) {
        // Neues HTML ohne Leiste (sollte bei aktivem Filter nicht vorkommen): Leiste ausblenden
        var scOnly = thumbs.closest('slider-component');
        if (scOnly) scOnly.classList.add('sjb-hide');
      }
      if (thumbs && newThumbs) {
        var existing = {};
        thumbs.querySelectorAll('li[data-target]').forEach(function (li) { existing[li.dataset.target] = li; });
        newThumbs.querySelectorAll('li[data-target]').forEach(function (nli) {
          var li = existing[nli.dataset.target];
          if (!li) return;
          li.classList.toggle('sjb-hide', nli.classList.contains('sjb-hide'));
          thumbs.appendChild(li);
        });
        var sc = thumbs.closest('slider-component');
        var nsc = newThumbs.closest('slider-component');
        if (sc && nsc) {
          sc.className = nsc.className;
          ['prev', 'next'].forEach(function (k) {
            var b = sc.querySelector('.slider-button--' + k);
            var nb = nsc.querySelector('.slider-button--' + k);
            if (b && nb) b.className = nb.className;
          });
          if (typeof sc.resetPages === 'function') sc.resetPages();
        }
      }

      var tot = gallery.querySelector('.slider-counter--total');
      var ntot = data.html.querySelector('.slider-counter--total');
      if (tot && ntot) tot.textContent = ntot.textContent;
      var btns = gallery.querySelector('[id^="GalleryViewer"] .slider-buttons');
      var nbtns = data.html.querySelector('[id^="GalleryViewer"] .slider-buttons');
      if (btns && nbtns) btns.className = nbtns.className;
      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (viewer && typeof viewer.resetPages === 'function') viewer.resetPages();
      var newGallery = data.html.querySelector('media-gallery');
      if (newGallery && newGallery.dataset.sjbKleur) gallery.dataset.sjbKleur = newGallery.dataset.sjbKleur;
    });
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) return false;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) { sync(event && event.data); });
    return true;
  }
  if (!init()) document.addEventListener('DOMContentLoaded', init);
})();
